import RootElement from './src/RootElement'

export const wrapRootElement = RootElement;